import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store';

export interface MenuState {
    backButtonVisible: boolean
    addPartyEventVisible: boolean
    savePartyEventVisible: boolean
    addEventTaskVisible: boolean
    saveEventTaskVisible: boolean
    addEventUserVisible: boolean
    saveEventUserVisible: boolean
    promptOkCancelOnBack : boolean
    promptOkCancelOnHome : boolean
    promtOkCancelOnDelete : boolean
    notificationsButton : boolean
    informationButton : boolean
    homeButtonVisible : boolean
    reloadButtonVisible : boolean
    notificationReloadButton : boolean
}

const initialState: MenuState = {
    backButtonVisible: false,
    addPartyEventVisible: false,
    savePartyEventVisible: false,
    addEventTaskVisible: false,
    saveEventTaskVisible: false,
    addEventUserVisible: false,
    saveEventUserVisible: false,
    promptOkCancelOnBack: false,
    promptOkCancelOnHome : false,
    promtOkCancelOnDelete: false,
    notificationsButton: false,
    informationButton: false,
    homeButtonVisible: false,
    reloadButtonVisible: false,
    notificationReloadButton: false
}

export const menuSlice = createSlice({
    name: 'menu',
    initialState: initialState,
    reducers: {
        resetButtons: (state) => {
            state.backButtonVisible = false
            state.addPartyEventVisible = false
            state.savePartyEventVisible = false
            state.addEventTaskVisible = false
            state.saveEventTaskVisible = false
            state.addEventUserVisible = false
            state.saveEventUserVisible = false
            state.promptOkCancelOnBack = false
            state.promptOkCancelOnHome = false
            state.promtOkCancelOnDelete = false
            state.notificationsButton = false
            state.informationButton = false
            state.homeButtonVisible = false
            state.reloadButtonVisible = false
            state.notificationReloadButton = false
        },
        deleteButtons: (state) => {
            state.promtOkCancelOnDelete = false
        },
        setBackButtonVisible: (state, action: PayloadAction<boolean>) => {
            state.backButtonVisible = action.payload
        },
        setAddPartyEventVisible: (state, action: PayloadAction<boolean>) => {
            state.addPartyEventVisible = action.payload
        },
        setSavePartyEventVisible: (state, action: PayloadAction<boolean>) => {
            state.savePartyEventVisible = action.payload
        },
        setAddEventTaskVisible: (state, action: PayloadAction<boolean>) => {
            state.addEventTaskVisible = action.payload
        },
        setSaveEventTaskVisible: (state, action: PayloadAction<boolean>) => {
            state.saveEventTaskVisible = action.payload
        },
        setAddEventUserVisible: (state, action: PayloadAction<boolean>) => {
            state.addEventUserVisible = action.payload
        },
        setSaveEventUserVisible: (state, action: PayloadAction<boolean>) => {
            state.saveEventUserVisible = action.payload
        },
        setPromptOkCancelOnBack: (state, action: PayloadAction<boolean>) => {
            state.promptOkCancelOnBack = action.payload
        },
        setPromtOkCancelOnDelete: (state, action: PayloadAction<boolean>) => {
            state.promtOkCancelOnDelete = action.payload
        },
        setNotificationsButtonVisible: (state, action: PayloadAction<boolean>) => {
            state.notificationsButton = action.payload
        },
        setInformationButtonVisible: (state, action: PayloadAction<boolean>) => {
            state.informationButton = action.payload
        },
        setHomeButtonVisible: (state, action: PayloadAction<boolean>) => {
            state.homeButtonVisible = action.payload
        },
        setPromptOkCancelOnHome: (state, action: PayloadAction<boolean>) => {
            state.promptOkCancelOnHome = action.payload
        },
        setReloadButtonVisible: (state, action: PayloadAction<boolean> ) => {
            state.reloadButtonVisible = action.payload
        },
        setNotificationReloadButton: (state, action : PayloadAction<boolean>) => {
            state.notificationReloadButton = action.payload
        }
    }
})


export const selectBackButtonVisible = (state: RootState) => state.menu.backButtonVisible
export const selectAddPartyEventVisible = (state: RootState) => state.menu.addPartyEventVisible
export const selectSavePartyEventVisible = (state: RootState) => state.menu.savePartyEventVisible
export const selectAddEventTaskVisible = (state: RootState) => state.menu.addEventTaskVisible
export const selectSaveEventTaskButtonVisible = (state: RootState) => state.menu.saveEventTaskVisible
export const selectAddEventUserButtonVisible = (state: RootState) => state.menu.addEventUserVisible
export const selectSaveEventUserButtonVisible = (state: RootState) => state.menu.saveEventUserVisible
export const selectPromptOkCancelOnClick = (state: RootState) => state.menu.promptOkCancelOnBack
export const selectPromptOkCancelOnHome = (state: RootState) => state.menu.promptOkCancelOnHome
export const selectPromptOkDeleteOnClick = (state: RootState) => state.menu.promtOkCancelOnDelete
export const selectNotificationsButtonVisible = (state: RootState) => state.menu.notificationsButton
export const selectInformationButtonVisible = (state: RootState) => state.menu.informationButton
export const selectHomeButtonVisible = (state: RootState) => state.menu.homeButtonVisible
export const selectReloadButtonVisible = (state : RootState) => state.menu.reloadButtonVisible
export const selectNotificationReloadButton = (state: RootState) => state.menu.notificationReloadButton


export const { 
    resetButtons, 
    deleteButtons,
    setBackButtonVisible,
    setAddPartyEventVisible, 
    setSavePartyEventVisible,
    setAddEventTaskVisible, 
    setSaveEventTaskVisible,
    setAddEventUserVisible,
    setSaveEventUserVisible,
    setPromptOkCancelOnBack,
    setPromptOkCancelOnHome,
    setNotificationsButtonVisible,
    setInformationButtonVisible,
    setHomeButtonVisible,
    setReloadButtonVisible,
    setNotificationReloadButton
} = menuSlice.actions
export default menuSlice.reducer
